import { Link } from "react-router-dom";
import { type BlogPost as BlogPostType } from "../services/bloggerApi";

interface BlogPostProps {
  post: BlogPostType;
  variant?: "project" | "event";
}

const BlogPost = ({ post, variant = "project" }: BlogPostProps) => {
  const mainImage = post.images?.[0];
  const formattedDate = new Date(post.published).toLocaleDateString("tr-TR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Link to={`/etkinliklerimiz/${post.id}`}>
      <article className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 h-[28rem] flex flex-col">
        {mainImage ? (
          <div className="relative h-48 overflow-hidden flex-shrink-0">
            <img
              src={mainImage}
              alt={post.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
        ) : (
          <div className="h-48 bg-gray-100 flex-shrink-0" />
        )}
        <div className="p-6 flex flex-col flex-grow">
          <div className="flex items-center gap-4 mb-4">
            {post.author.image?.url ? (
              <img
                src={post.author.image.url}
                alt={post.author.displayName}
                className="w-10 h-10 rounded-full"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-gray-200" />
            )}
            <div>
              <p className="text-sm font-medium text-gray-900">
                {post.author.displayName}
              </p>
              <p className="text-sm text-gray-500">{formattedDate}</p>
            </div>
          </div>

          <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
            {post.title}
          </h2>

          <div
            className="text-gray-600 mb-4 line-clamp-3 prose flex-grow"
            dangerouslySetInnerHTML={{
              __html: post.content.split("</p>")[0] + "</p>",
            }}
          />

          <p
            className={`inline-flex items-center text-sm font-medium mt-auto ${
              variant === "project"
                ? "text-blue-600 hover:text-blue-700"
                : "text-purple-600 hover:text-purple-700"
            }`}
          >
            Devamını Oku
            <svg
              className="ml-1 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </p>
        </div>
      </article>
    </Link>
  );
};

export default BlogPost;
